import { takeLatest, put, call } from "redux-saga/effects";
import {
  ALARM_PAGE_GET_DATA, ALARM_PAGE_DATA_GET_API,
  ALARM_PAGE_GET_DETAILS_DATA, ALARM_PAGE_GET_DETAIL_API,
  ALARM_PAGE_UPDATE_DATA, ALARM_PAGE_POST_API,
} from "./Constants";
import {
  setAlarmPageDataFail, setAlarmPageDataSuccess,
  setAlarmPageGetDetailsFail, setAlarmPageGetDetailsSuccess,
  setAlarmPageUpdateDataFail, setAlarmPageUpdateDataSuccess,
} from "./Actions";
import { addErrorAlert, addSuccessAlert } from "../../alert/Actions";
import { getLocalData, getDetailRequest, putRequest, getRequest } from "../../../shared/components/Service";

function* getAlarmPageDataService() {
  try {
    const response = yield call(getRequest, ALARM_PAGE_DATA_GET_API);
    if (response.status === 200) {
      yield put(setAlarmPageDataSuccess(response.data));
    } else {
      yield put(setAlarmPageDataFail(response.response.data.msg));
    }
  } catch (error) {
    yield put(setAlarmPageDataFail(error));
  }
}

function* getAlarmPageDetailsService({ id }) {
  try {
    const response = yield call(getDetailRequest, ALARM_PAGE_GET_DETAIL_API + id);
    if (response.status === 200) {
      yield put(setAlarmPageGetDetailsSuccess(response.data.data));
    } else {
      yield put(setAlarmPageGetDetailsFail(response.response.data.msg));
    }
  } catch (error) {
    yield put(setAlarmPageGetDetailsFail(error));
  }
}

function* updateAlarmPageDataService({ request }) {
  try {
    const response = yield call(putRequest, ALARM_PAGE_POST_API, request);
    if (response.status === 200) {
      yield put(addSuccessAlert("Status updated successfully"));
      yield put(setAlarmPageUpdateDataSuccess(response.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg));
      yield put(setAlarmPageUpdateDataFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Could not update status"));
    yield put(setAlarmPageUpdateDataFail(error));
  }
}

export function* watchAlarmPage() {
  yield takeLatest(ALARM_PAGE_GET_DATA.ALARM_PAGE_GET_DATA_LOAD, getAlarmPageDataService);
  yield takeLatest(ALARM_PAGE_GET_DETAILS_DATA.ALARM_PAGE_GET_DETAILS_DATA_LOAD, getAlarmPageDetailsService);
  yield takeLatest(ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_LOAD, updateAlarmPageDataService);
}